import { Brightness5Icon } from './Brightness5Icon';

/**
 * author: Google
 * id 17314413-99ED-480C-B739-8572B6AE5477
 * name brightness-5
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/brightness-5.svg
 * tags
 */
export const BrightnessLowIcon = Brightness5Icon;
export default BrightnessLowIcon